import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { PageHeader, Loading, DemoBadge } from "../../components/shared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

export default function AdminSocieties() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/societies").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;
  return (
    <div>
      <PageHeader title="Societies" subtitle={`${rows.length} registered societies`} />
      <div className="bg-card border rounded-xl overflow-hidden overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Reg No</TableHead><TableHead>City</TableHead><TableHead>Flats</TableHead><TableHead>Plan</TableHead><TableHead>Created</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((s) => (
              <TableRow key={s.society_id} data-testid={`admin-society-${s.society_id}`}>
                <TableCell className="font-medium">
                  <Link data-testid={`admin-society-overview-${s.society_id}`} to={`/admin/societies/${s.society_id}/setup`}>
                    {s.name}
                  </Link>
                  {" "}{s.is_demo && <DemoBadge />}
                </TableCell>
                <TableCell>{s.registration_number}</TableCell><TableCell>{s.city}</TableCell><TableCell>{s.flats}</TableCell>
                <TableCell><span className="text-xs rounded-full bg-secondary/10 text-secondary px-2 py-0.5 capitalize">{s.plan}</span></TableCell>
                <TableCell>{(s.created_at || "").slice(0, 10)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
